import { createContext } from "react";

export const AttributesContext = createContext();
export const AttributesProvider = AttributesContext.Provider;
export const AttributesConsumer = AttributesContext.Consumer;

export const AttributeGroupDataContext = createContext();
export const AttributeGroupDataProvider = AttributeGroupDataContext.Provider;
export const AttributeGroupDtaConsumer = AttributeGroupDataContext.Consumer;

export const AttributeVarietyDataContext = createContext();
export const AttributeVarietyDataProvider = AttributeVarietyDataContext.Provider;
export const AttributeVarietyDataConsumer = AttributeVarietyDataContext.Consumer;

export const ProductsContext = createContext();
export const ProductsProvider = ProductsContext.Provider;
export const ProductsConsumer = ProductsContext.Consumer;
